import consumer from "./consumer";

export function subscribeToAttachment(attachmentId, callbacks) {
  console.log(`[AttachmentChannel] Subscribing to attachment ${attachmentId}`);

  return consumer.subscriptions.create(
    {
      channel: "AttachmentChannel",
      attachment_id: attachmentId,
    },
    {
      connected() {
        console.log(
          `[AttachmentChannel] Connected to attachment ${attachmentId}`
        );
        if (callbacks.connected) {
          callbacks.connected();
        }
      },

      disconnected() {
        console.log(
          `[AttachmentChannel] Disconnected from attachment ${attachmentId}`
        );
        if (callbacks.disconnected) {
          callbacks.disconnected();
        }
      },

      received(data) {
        console.log(
          `[AttachmentChannel] Received data for attachment ${attachmentId}:`,
          data
        );
        if (callbacks.received) {
          callbacks.received(data);
        }
      },
    }
  );
}
